import { action } from 'typesafe-actions';

import { NavigationActionTypes } from './types';

export const toggleLeftMenu = (isOpen: boolean) => action(NavigationActionTypes.TOGGLE_LEFT_MENU, isOpen);

export const toggleRightMenu = (isOpen: boolean) => action(NavigationActionTypes.TOGGLE_RIGHT_MENU, isOpen);
